import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { i18n } from '../core/i18n.js';
import { updateDashboard } from './dashboard.js';

const LANG_FLAGS = { fr: '🇫🇷', en: '🇬🇧', es: '🇪🇸', tlh: '🖖' };

export function toggleLangPicker(id) {
    const picker = document.getElementById(id);
    if (!picker) return;
    const wasOpen = picker.classList.contains('is-open');
    document.querySelectorAll('.lang-picker.is-open').forEach(p => p.classList.remove('is-open'));
    if (!wasOpen) picker.classList.add('is-open');
}

export function updateLangPickers() {
    const locale = localStorage.getItem('chaos_locale') || 'fr';
    const flag = LANG_FLAGS[locale] || '🌐';
    document.querySelectorAll('.lp-flag').forEach(el => el.textContent = flag);
    document.querySelectorAll('.lp-option').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.lang === locale);
    });
}

export async function changerLangue(locale) {
    localStorage.setItem('chaos_locale', locale);
    if (typeof window._pousserPrefs === 'function') window._pousserPrefs({ locale });
    
    document.querySelectorAll('.lang-picker.is-open').forEach(p => p.classList.remove('is-open'));
    await i18n.load(locale);
    
    if (typeof updateDashboard === 'function') updateDashboard(); 
    
    const activeDestId = window.destinataireID || state.destinataireID;
    const activeSalonId = window.salonActuelID || state.salonActuelID;
    
    if (activeDestId) {
        if (typeof window.updateChatHeader === 'function') window.updateChatHeader(activeDestId);
    } else if (!activeSalonId) {
        if (typeof window.nettoyerHeaderGlobal === 'function') window.nettoyerHeaderGlobal(); 
    }
    
    socket.emit('demander-liste-amis');
}

export function initLangPickerEvents() {
    // Fermeture du picker si clic en dehors
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.lang-picker')) {
            document.querySelectorAll('.lang-picker.is-open').forEach(p => p.classList.remove('is-open'));
        }
    });
}